// @flow

// Ensure consistent naming.
window.RTCPeerConnection =
  window.RTCPeerConnection ||
  window.mozRTCPeerConnection ||
  window.webkitRTCPeerConnection;
window.RTCIceCandidate =
  window.RTCIceCandidate ||
  window.mozRTCIceCandidate ||
  window.webkitRTCIceCandidate;
window.RTCSessionDescription =
  window.RTCSessionDescription ||
  window.mozRTCSessionDescription ||
  window.webkitRTCSessionDescription;

declare var RTCPeerConnection: any;
declare var RTCSessionDescription: any;
declare var RTCIceCandidate: any;

export default class LiveSourceAPI {
  remoteVideo: HTMLVideoElement;
  peerConnection: RTCPeerConnection = null;
  peerConnectionConfig = { iceServers: [] };
  localStream = null;
  wsURL = "wss://webrtc.switchmedia.asia/webrtc-session.json";
  wsConnection: ?WebSocket = null;
  streamInfo = {
    applicationName: "webrtc",
    streamName: "adease",
    sessionId: "[empty]"
  };
  userData = { param1: "value1" };
  repeaterRetryCount = 0;
  newAPI = false;
  doGetAvailableStreams = false;

  constructor(videoElement: HTMLVideoElement) {
    if (videoElement == null) {
      throw new Error(
        "videoElement passed to LiveSourceAPI cannot be null or undefined"
      );
    }
    this.remoteVideo = videoElement;

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      this.newAPI = false;
    }

    console.log("newAPI: " + String(this.newAPI));
  }

  wsConnect(url: string) {
    this.wsConnection = new WebSocket(url);
    this.wsConnection.binaryType = "arraybuffer";

    this.wsConnection.onopen = () => {
      console.log("wsConnection.onopen");

      this.peerConnection = new RTCPeerConnection(this.peerConnectionConfig);
      this.peerConnection.onicecandidate = this.gotIceCandidate;

      if (this.newAPI) {
        this.peerConnection.ontrack = this.gotRemoteTrack.bind(this);
      } else {
        this.peerConnection.onaddstream = this.gotRemoteStream.bind(this);
      }

      console.log("wsURL: " + this.wsURL);
      if (this.doGetAvailableStreams) {
        sendPlayGetAvailableStreams();
      } else {
        sendPlayGetOffer();
      }
    };

    const sendPlayGetOffer = () => {
      console.log("sendPlayGetOffer: " + JSON.stringify(this.streamInfo));
      if (!this.wsConnection) {
        return;
      }
      this.wsConnection.send(
        '{"direction":"play", "command":"getOffer", "streamInfo":' +
          JSON.stringify(this.streamInfo) +
          ', "userData":' +
          JSON.stringify(this.userData) +
          "}"
      );
    };

    const sendPlayGetAvailableStreams = () => {
      console.log(
        "sendPlayGetAvailableStreams: " + JSON.stringify(this.streamInfo)
      );
      if (!this.wsConnection) {
        return;
      }
      this.wsConnection.send(
        '{"direction":"play", "command":"getAvailableStreams", "streamInfo":' +
          JSON.stringify(this.streamInfo) +
          ', "userData":' +
          JSON.stringify(this.userData) +
          "}"
      );
    };

    this.wsConnection.onmessage = evt => {
      console.log("wsConnection.onmessage: " + String(evt.data));

      let msgJSON = JSON.parse(String(evt.data));

      let msgStatus = Number(msgJSON["status"]);
      let msgCommand = msgJSON["command"];

      if (msgStatus !== 200) {
        // repeater stream not ready
        this.repeaterRetryCount++;
        if (this.repeaterRetryCount < 10) {
          console.count("retrying");
          setTimeout(sendPlayGetOffer, 500);
        } else {
          this.stopPlay();
        }
      } else {
        let streamInfoResponse = msgJSON["streamInfo"];
        if (streamInfoResponse !== undefined) {
          this.streamInfo.sessionId = streamInfoResponse.sessionId;
        }

        let sdpData = msgJSON["sdp"];
        if (sdpData !== undefined) {
          console.log("sdp: " + JSON.stringify(msgJSON["sdp"]));

          this.peerConnection.setRemoteDescription(
            new RTCSessionDescription(msgJSON.sdp),
            () => {
              this.peerConnection.createAnswer(
                this.gotDescription.bind(this),
                this.errorHandler
              );
            },
            this.errorHandler
          );
        }

        let iceCandidates = msgJSON["iceCandidates"];
        if (iceCandidates !== undefined) {
          for (let index in iceCandidates) {
            console.log(
              "iceCandidates: " + JSON.stringify(iceCandidates[index])
            );
            this.peerConnection.addIceCandidate(
              new RTCIceCandidate(iceCandidates[index])
            );
          }
        }
      }

      if ("sendResponse".localeCompare(msgCommand) === 0) {
        if (this.wsConnection != null) this.wsConnection.close();
        this.wsConnection = null;
      }
      // now check for getAvailableResponse command to close the connection
      if ("getAvailableStreams".localeCompare(msgCommand) === 0) {
        this.stopPlay();
      }
    };

    this.wsConnection.onclose = function() {
      console.log("wsConnection.onclose");
    };

    this.wsConnection.onerror = function(evt) {
      console.log("wsConnection.onerror: " + JSON.stringify(evt));
    };
  }

  getAvailableStreams() {
    this.doGetAvailableStreams = true;
    this.startPlay();
  }

  startPlay() {
    this.repeaterRetryCount = 0;

    console.log(
      "startPlay: wsURL:" +
        this.wsURL +
        " streamInfo:" +
        JSON.stringify(this.streamInfo)
    );

    this.wsConnect(this.wsURL);

    if (!this.doGetAvailableStreams) {
    }
  }

  stopPlay() {
    if (this.peerConnection != null) this.peerConnection.close();
    this.peerConnection = null;

    if (this.wsConnection != null) this.wsConnection.close();
    this.wsConnection = null;

    if (this.remoteVideo) {
      ((this.remoteVideo: any): HTMLMediaElement).src = ""; // this seems like a chrome bug - if set to null it will make HTTP request
    }
    console.log("stopPlay");
  }

  // start button clicked
  start() {
    console.count("start button clicked");
    this.doGetAvailableStreams = false;

    if (this.peerConnection == null) this.startPlay();
    else this.stopPlay();
  }

  gotMessageFromServer(message: any) {
    let signal = JSON.parse(message.data);
    if (signal.sdp) {
      if (signal.sdp.type === "offer") {
        console.log("sdp:offser");
        console.log(signal.sdp.sdp);
        this.peerConnection.setRemoteDescription(
          new RTCSessionDescription(signal.sdp),
          () => {
            this.peerConnection.createAnswer(
              this.gotDescription,
              this.errorHandler
            );
          },
          this.errorHandler
        );
      } else {
        console.log("sdp:not-offer: " + signal.sdp.type);
      }
    } else if (signal.ice) {
      console.log("ice: " + JSON.stringify(signal.ice));
      this.peerConnection.addIceCandidate(new RTCIceCandidate(signal.ice));
    }
  }

  gotIceCandidate(event: any) {
    if (event.candidate != null) {
    }
  }

  gotDescription(description: any) {
    console.log("gotDescription");
    this.peerConnection.setLocalDescription(
      description,
      () => {
        console.log("sendAnswer");

        if (!this.wsConnection) {
          return;
        }

        this.wsConnection.send(
          '{"direction":"play", "command":"sendResponse", "streamInfo":' +
            JSON.stringify(this.streamInfo) +
            ', "sdp":' +
            JSON.stringify(description) +
            ', "userData":' +
            JSON.stringify(this.userData) +
            "}"
        );
      },
      () => {
        console.log("set description error");
      }
    );
  }

  gotRemoteTrack(event: any) {
    console.log(
      "gotRemoteTrack: kind:" + event.track.kind + " stream:" + event.streams[0]
    );
    (this.remoteVideo: any).src = window.URL.createObjectURL(event.streams[0]);
  }

  gotRemoteStream(event: any) {
    console.log("gotRemoteStream: " + event.stream);
    console.log(this.remoteVideo);
    (this.remoteVideo: any).src = window.URL.createObjectURL(event.stream);
  }

  errorHandler(error: any) {
    console.log(error);
  }
}



// WEBPACK FOOTER //
// ./src/LiveSource/API.js